<template>
  <div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
      <FormItem label="名称">
        <Input v-if="isEdit" v-model="formValidate.name" placeholder="请输入名称..."></Input>
        <div v-else>{{formValidate.name}}</div>
      </FormItem>
      <FormItem label="数据">
        <textarea v-if="isEdit" v-model="formValidate.data" placeholder="" style="width: 100%;"></textarea>
        <div v-else>{{formValidate.auth}}</div>
      </FormItem>
      <FormItem label="描述">
        <textarea v-if="isEdit" v-model="formValidate.description" placeholder="请输入描述..." style="width: 100%;"></textarea>
        <div v-else>{{formValidate.description}}</div>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { AuthItemsService } from '@/services/resources'
import { AuthItemType } from '@/services/const'

export default {
  name: 'RolesPopForm',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    channelTypes: {
      type: Array,
      default: function () {
        return []
      }
    },
    data: Object
  },
  data () {
    return {
      formValidate: { ...this.data },
      ruleValidate: {}
    }
  },
  methods: {
    formSubmit () {
      let { id, name, description, data } = this.formValidate
      let postData = {
        id, name, description, type: AuthItemType.Role, data
      }
      return AuthItemsService.update(postData)
    }
  },
  watch: {
    'data' (nVal) {
      this.formValidate = nVal
    },
    'visible' () {
      this.formValidate = { ...this.data }
    }
  }
}
</script>
